export const initialState = {
  entities: {},
  result: []
};

export const notifications = (model) => model && model.entities;
export const notificationsRefs = (model) => model && model.result;
